import React from 'react';
import { LockKey, Warning } from '@phosphor-icons/react';

/**
 * Operator-confirmed CERT source-agency lock (read-only summary from
 * GET /certification/source-agency-lock). Never creates or edits an agency.
 */
export const CertSourceAgencyLockBanner = ({ lock }) => {
  if (!lock) return null;
  if (!lock.locked) {
    return (
      <div className="mb-3 rounded-md border border-red-300 bg-red-50 p-3 text-xs text-red-800"
           data-testid="cert-source-lock-banner">
        <Warning size={14} className="inline mr-1" />
        {lock.conflict
          ? `Source-agency lock configuration conflict (${lock.conflict}) — every REAL MEMBER CERT run is refused until resolved.`
          : 'No CERT source-agency lock resolved — REAL MEMBER CERT runs are refused (fail closed).'}
      </div>
    );
  }
  const rec = lock.record;
  const bound = Boolean(rec && rec.bound);
  return (
    <div
      className={`mb-3 rounded-md border p-3 text-xs ${bound
        ? 'border-emerald-300 bg-emerald-50 text-emerald-900'
        : 'border-amber-300 bg-amber-50 text-amber-900'}`}
      data-testid="cert-source-lock-banner"
    >
      <div className="flex items-center gap-1 font-semibold">
        <LockKey size={14} /> REAL MEMBER CERT runs are locked to one source agency in every environment
      </div>
      <div className="mt-1 font-mono" data-testid="cert-source-lock-identity">
        {lock.name} · NPI {lock.npi} · id {lock.agency_id}
      </div>
      <div className="mt-1" data-testid="cert-source-lock-record-state">
        {bound
          ? `Agency record found in this environment, active, NPI check-digit valid — bound.`
          : rec && rec.found
            ? `Agency record found but NOT bound (${rec.reason || (rec.active ? 'mismatch' : 'inactive')}) — REAL MEMBER generation refused until the operator re-confirms the record.`
            : 'Locked agency record is NOT present in this environment — REAL MEMBER generation is refused here (fail closed). No agency is created.'}
        {!lock.mandatory && (
          <span className="block mt-0.5 text-slate-600" data-testid="cert-source-lock-synthetic-note">
            Synthetic / structure-only runs are not agency-locked in this non-production environment.
          </span>
        )}
      </div>
    </div>
  );
};

export default CertSourceAgencyLockBanner;
